// @ts-nocheck
import React, { useEffect, useState } from 'react'
import axios from '../../api/axios.js';
import { notify } from '../toast';
import '../../styles/hospital.css';
import { useNavigate, useParams } from 'react-router-dom';
const Hospital = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const [photo, setPhoto] = useState('');
    const [hospital, setHospital] = useState({});


    const bufferToBase64 = (bufferArray) => {
        const chunkSize = 100000;
        let base64String = '';

        for (let i = 0; i < bufferArray.length; i += chunkSize) {
            const chunk = bufferArray.slice(i, i + chunkSize);
            base64String += String.fromCharCode.apply(null, chunk);
        }

        return btoa(base64String);
    }

    useEffect(() => {
        fetchHospital();
        // eslint-disable-next-line
    }, []);

    const fetchHospital = async () => {
        try {

            const response = await axios.get("/public/hospital/" + id);

            const data = response?.data
            setHospital(data)

            if (data?.photo) setPhoto(`data:image/jpeg;base64,${bufferToBase64(data?.photo?.data)}`);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
            navigate('/')
        }
    }

    return (
        <div className='hospital-container'>

            {Object.keys(hospital).length !== 0 &&
                <>
                    < section className='hospital-header' >

                        <div className='hospital-heading'>
                            <h2>{hospital?.name}</h2>
                            <a href={hospital?.location}>{`${hospital?.area}, ${hospital?.village}, ${hospital?.mandal}, ${hospital?.district}`}</a>
                        </div>

                        <div className='hospital-photo'>
                            {photo ? (
                                <img style={{
                                    height: '15rem',
                                    borderRadius: '0.5rem',
                                    outline: '1px solid var(--primary-color)',
                                    outlineOffset: '3px'
                                }} src={photo} alt="" />
                            ) :
                                <div>
                                    No photo
                                </div>
                            }
                        </div>

                    </section >

                    <section className='hospital-contact'>
                        <div>
                            <a href={`mailto:${hospital?.email}`}>{hospital?.email}</a>
                            <a href={`tel:${hospital?.mobile}`}>+91 {hospital?.mobile}</a>
                        </div>
                    </section>

                    <section className='hospital-about'>
                        <h2>About us</h2>
                        <p>
                            {hospital?.about}
                        </p>
                    </section >

                    <section className='hospital-doctors'>
                        <section>
                            <h2>Our doctors</h2>
                            <div className='doctors-container'>
                                {hospital?.doctors?.map((item, index) => (
                                    <div key={index} className="doctor-card">
                                        <p>{item.name}</p>
                                        <p>{item.speciality}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </section>

                    <br />
                </>
            }
        </div >
    )
}

export default Hospital
